<form [formGroup]="dateRangeForm">
    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input
            [rangePicker]="picker"
            [max]="maxDateAllowed"
            [min]="minDateAllowed"
            [disabled]="isLoading"
        >
            <input
                matStartDate
                formControlName="start"
                placeholder="From"
                (dateChange)="dateChange('startDate', $event)"
            />
            <input matEndDate formControlName="end" (dateChange)="dateChange('endDate', $event)" placeholder="To" />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker" />
        <mat-date-range-picker #picker [calendarHeaderComponent]="calendarHeader" />
    </mat-form-field>
</form>
